module.exports = __webpack_public_path__ + "static/media/Dcard.43a89bad.png";